import {
    AppStateStatusBarItem,
    CurrentTimeStatusBarItem,
    FlightCountsStatusBarItem,
    IntegrationStatusBarItem,
    LastUpdateTimeStatusBarItem,
    MyFleetStatusBarItem,
    NavDataVersionStatusBarItem,
    UDViewStatusBarItem,
    WeatherStatusBarItem
} from './StatusBarItems';
import './StatusBar.css';

export default function StatusBar() {
    return (
        <div id="status-bar" className="d-flex px-2 h-100 align-items-center justify-content-between">
            <AppStateStatusBarItem />
            <IntegrationStatusBarItem />
            <MyFleetStatusBarItem />
            <div className="flex-grow-1">
                <UDViewStatusBarItem />
            </div>
            <NavDataVersionStatusBarItem />
            <WeatherStatusBarItem />
            <FlightCountsStatusBarItem />
            <CurrentTimeStatusBarItem />
            <LastUpdateTimeStatusBarItem />
        </div>
    );
}
